
















































































import Vue from 'vue';
import store, { ProductDef } from '../store';
import { routeEnterHelper } from '../helpers';

function productOptions(product: ProductDef) {
    const results: Array<{
        id: string,
        attribute: string,
        option: string,
        isDifference: boolean,
    }> = [];
    if (product) {
        const po = product.options;
        store.state.attributes.forEach((attribute, key) => {
            const optionId = String(po[attribute.id]);
            const option = (optionId && attribute.options.find((o) => o.id === optionId)) || null;

            let isDifference = false;
            store.state.compare.forEach((compareProduct) => {
                if (optionId !== String(compareProduct.options[attribute.id])) {
                    isDifference = true;
                }
            });
            results.push({
                id: (option && option.id) || attribute.id,
                attribute: attribute.label,
                option: (option && option.label) || '',
                isDifference,
            });
        });
    }
    return results;
}

export default Vue.extend({
    computed: {
        compare() {
            return store.state.compare;
        },
        compareRows() {
            let rowProducts: ProductDef[] = [];
            const compareRows = [{ products: rowProducts }];

            store.state.compare.forEach((product) => {
                rowProducts.push(product);
                if (rowProducts.length === 2) {
                    rowProducts = [];
                    compareRows.push({ products: rowProducts });
                }
            });
            if (compareRows[compareRows.length - 1].products.length === 0) {
                compareRows.splice(compareRows.length - 1, 1);
            }

            return compareRows;
        },
        homePage() {
            return store.getters.homePage;
        },
        labels() {
            if (store.state.compare.length) {
                return productOptions(store.state.compare[0]);
            }
            return [];
        },
    },
    methods: {
        productForOrder(product: ProductDef) {
            store.dispatch('productForOrder', { product } ).then(() => {
                this.$router.push({ name: 'order'});
            });
        },
        removeProduct(product: ProductDef) {
            store.dispatch('removeCompareProduct', { product } ).then(() => {
                if (this.compare.length <= 1) {
                    this.$router.push({ name: 'product'});
                }
            });
        },
        productForDetail(product: ProductDef) {
            store.dispatch('product', { product } ).then(() => {
                this.$router.push({ name: 'product'});
            });
        },
        productOptions(product: ProductDef) {
            return productOptions(product);
        },
    },
    beforeRouteEnter(to, from, next) {
        routeEnterHelper(store.state.compare.length > 0, from, next);
    },
});
